import { useTranslation } from "react-i18next";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { UserFormNodeData } from "@/lib/productGraph";

import { WizardFieldListEditor } from "../wizard-field-list-editor";

interface Props {
  data: UserFormNodeData;
  onChange: (patch: Partial<UserFormNodeData>) => void;
}

export function UserFormEditor({ data, onChange }: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label className="text-xs">{t("enterpriseProductBuilder.nodeLabelLabel")}</Label>
        <Input
          value={data.label}
          onChange={(e) => onChange({ label: e.target.value })}
        />
      </div>

      <div className="space-y-1.5">
        <Label className="text-xs">
          {t("enterpriseProductBuilder.nodeDescriptionLabel")}
        </Label>
        <Textarea
          value={data.description ?? ""}
          onChange={(e) => onChange({ description: e.target.value })}
          rows={2}
        />
      </div>

      <WizardFieldListEditor
        fields={data.fields ?? []}
        onChange={(fields) => onChange({ fields })}
      />
    </div>
  );
}
